<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-card-title class="pa-0">
          <v-row no-gutters>
            <v-col class="pa-4" cols="12" md="6">
              <p class="break-word">
                <span class="small-font grey--text">{{
                  $t("product_sp.edit")
                }}</span>
                {{ translatedProductName }}
              </p>
            </v-col>

            <v-col
              class="pa-4 d-flex justify-end align-start"
              cols="12"
              md="6"
              style="gap: 8px"
            >
              <v-btn
                class="rounded-lg"
                color="red"
                outlined
                @click="$emit('close')"
              >
                {{ $t("product_sp.back") }}
              </v-btn>

              <v-btn
                :disabled="!canSave"
                class="rounded-lg"
                color="success"
                depressed
                @click="saveEdit"
              >
                {{ $t("product_sp.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-subtitle>
          {{ $t("product_sp.add_product_to_special_category") }}
        </v-card-subtitle>

        <v-row class="pa-2" no-gutters>
          <v-col class="pa-2" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="temp_obj.total_quantity"
                :rules="[rules.empty]"
                append-icon="mdi-counter"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-spin-buttons
                :label="$t('product_sp.inventory')"
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-temp_obj-total_quantity`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('product_sp.inventory')"
              />
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="temp_obj.total_discount"
                append-icon="mdi-percent-outline"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-spin-buttons
                :label="$t('product_sp.discount')"
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-temp_obj-total_discount`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('product_sp.discount')"
              />
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="temp_obj.max_per_customer"
                append-icon="mdi-account-details-outline"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-spin-buttons
                :label="$t('product_sp.max_per_customer')"
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-temp_obj-max_per_customer`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('product_sp.max_per_customer')"
              />
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <div class="rowinfo">
              <v-text-field
                v-model="temp_obj.max_per_order"
                append-icon="mdi-basket-outline"
                class="rounded-lg contentinfo"
                clearable
                dense
                hide-spin-buttons
                :label="$t('product_sp.max_per_order')"
                outlined
                type="number"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-temp_obj-max_per_order`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('product_sp.max_per_order')"
              />
            </div>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <div class="rowinfo">
              <custom-date-picker
                v-model="temp_obj.expires_at"
                :min="nowDateTimeString()"
                append-icon="mdi-calendar-range"
                clearable
                dense
                :label="$t('product_sp.expires_at')"
                nullable
                outlined
                wrapper-class="rounded-lg"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-temp_obj-expires_at`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="$t('product_sp.expires_at')"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import CustomDatePicker from "@/core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  name: "specialProductEditor",

  components: { CustomDatePicker },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      componentName: "specialproductEditor",
      serviceName: "Qrland",
      errors: {},
      temp_obj: {
        product_id: "",
        special_category_id: "",
        total_quantity: "",
        total_discount: "",
        max_per_customer: "",
        max_per_order: "",
        expires_at: "",
      },
    };
  },

  created() {
    !!this.value &&
      !!Object.keys(this.value)?.length &&
      (this.temp_obj = { ...this.value });
  },

  computed: {
    rules() {
      return {
        empty: (v) => !!v || this.$t("product_sp.field_cannot_be_empty"),
      };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    canSave() {
      return Object.keys(this.temp_obj).every((item) => !!this.temp_obj[item]);
    },
    translatedProductName() {
      return (
        this.$t(`product_sp.products.${this.temp_obj.product_id}`) ||
        this.temp_obj.name
      );
    },
  },

  methods: {
    saveEdit() {
      this.errors = {};

      Object.keys(this.temp_obj).forEach((key) => {
        if (!this.temp_obj[key])
          this.errors[key] = this.$t("product_sp.field_cannot_be_empty");
      });

      if (!Object.keys(this.errors)?.length) {
        this.computedValue = { ...this.temp_obj };
        this.$emit("close");
      } else {
        this.$toast.error(this.$t("product_sp.please_enter_correctly"));
      }
    },
    nowDateTimeString() {
      return new Date().toISOString().slice(0, 16);
    },
  },
};
</script>

<style scoped>
:deep(.v-application--is-rtl) {
  direction: rtl;
}
</style>
